import { useCallback } from "react"

import { useTranscribeAgentVoice } from "openapi/api/endpoints"
import {
  robinVoiceTranscriptionRequestOptions,
  robinVoiceTranscriptionResultFromRequest,
} from "../api/voice-transcription-client"

/**
 * Wires Robin's generated OpenAPI voice mutation into a recorder-friendly
 * callback. ChatPane stays focused on composer UI, while this hook owns the
 * mutation lifecycle boundary used by `useDictation`.
 */
export function useRobinVoiceTranscription() {
  const { mutateAsync: transcribeAgentVoice } = useTranscribeAgentVoice({
    request: robinVoiceTranscriptionRequestOptions,
  })

  return useCallback(
    (audioFile: File) =>
      robinVoiceTranscriptionResultFromRequest(
        transcribeAgentVoice({
          data: {
            audio: audioFile,
          },
        }),
      ),
    [transcribeAgentVoice],
  )
}
